import { logWrapper } from '../../utils';

export default {
  emailService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $http, $q, $filter, webApiSettings) {
      'use strict';

      function handleError(err) {
        return {
          statusCode: err.status,
          title: $filter('translate')('SERVER OFFLINE'),
          text: $filter('translate')('SERVER OFFLINE MESSAGE'),
        };
      }

      function send(idRevision, emails) {
        var deferred = $q.defer();

        var urlBase = window.location.origin + '/#/public/view/';
        var lnkBase = btoa(urlBase)  // Converte para Base64
          .replace(/\+/g, '-') // Substitui "+" por "-"
          .replace(/\//g, '_') // Substitui "/" por "_"
          .replace(/=+$/, ''); // Remove "=" do final

        $http
          .post(webApiSettings.apiServiceBaseUri + 'email/sendwithpubliclink', {
            idRevision: idRevision,
            emails: emails,
            urlBase: lnkBase
          })
          .then(() => {
            deferred.resolve();
          })
          .catch((err, status, headers, config) => {
            var error = handleError(
              {
                err: err,
                status: status,
                headers: headers,
                config: config,
                data: {},
              },
              false,
              true
            );
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          var emailServiceFactory = {};

          emailServiceFactory.send = logWrapper(
            send,
            runtimeConstant.isDebugServicesInternals
          );

          return emailServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
